import {AccentColorOptions} from 'epic-ue-theme/src/types/colors.types';
import React from 'react';
import styled from 'styled-components';
import {Typography} from '..';
import {AnimateOnViewWrap} from '../../wraps/animation';

const Styled = styled.div<{accentColor?: AccentColorOptions}>`
    width: 83px;
    height: 83px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 2px solid
        ${(p) =>
            p.accentColor ? p.theme.palette.accent[p.accentColor] : p.theme.palette.text.primary};
    h2 {
        font-size: 32px;
    }
`;

export interface NumberedElipseProps {
    accentColor?: AccentColorOptions;
    text?: string | number;
}

export const NumberedElipse = ({
    accentColor = 'sky',
    text = ''
}: NumberedElipseProps): JSX.Element => {
    return (
        <AnimateOnViewWrap translateY={30}>
            <Styled className="ue-numbered-elipse" accentColor={accentColor}>
                <Typography variant="h2" as="span">{text}</Typography>
            </Styled>
        </AnimateOnViewWrap>
    );
};
